<template>
    <div id="TermsOfUse">
        <div class="container">
            <div class="row">
              <div class="col-12">
                  <!-- <div v-if="termsOfUse" class="ql-editor"> -->
                    <div  v-html="termsOfUse"></div>
                  <!-- </div> -->
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'quill/dist/quill.bubble.css';
export default {
  data(){
    return {
        termsOfUse: ""
    }
  },
  async created() {
    try{
        const { data: { results } }  = await this.$store.$oddjob.settings.getConfigTermsOfUser("terms_of_use_html");
        if(results && results.length){
            this.termsOfUse = results[0].value;
        }
    }catch(err){
        console.log("API get config ")
    }
  }
}
</script>

<style lang="scss">
#TermsOfUse{
  line-height: 26px;
  font-size: 14px;
  padding: 0px;
}
</style>
<style lang="scss" scoped>

</style>